export const breadcrumbsState = ({ data, component } = {}) => {
  if (!data) {
    return false;
  }
  return {
    data,
    component,
  };
};
